<template>
    <div id="user-create-view" class="view form-view">
        <h2>Edit Driver</h2>

        <driver-form :form="form" :handler="editDriver" is-edit-mode></driver-form>

        <br /><br />

        <div v-if="hasAllRoles(['VehicleView'])" class="form">
            <v-form
                ref="form"
                v-model="valid"
                lazy-validation
            >
                <v-layout>
                    <v-flex xs12>
                        <v-layout row>
                            <v-flex md12>
                                <div class="content-wrapper">
                                    <div class="info-block">
                                        Assign to Vehicle
                                    </div>
                                </div>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex md6>
                                <div class="content-wrapper">
                                    <v-layout row>
                                        <v-flex xs4>
                                            <div class="label text-xs-right">
                                                <span class="text-xs-right">Vehicle</span>
                                            </div>
                                        </v-flex>
                                        <v-flex xs8>
                                            <vehicle-autocomplete v-model="formVehicle.vehicle" :fleet="form.fleet"></vehicle-autocomplete>
                                        </v-flex>
                                    </v-layout>
                                </div>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex md6 class="">
                                <div class="content-wrapper text-xs-right">
                                    <sp-button @click.native="validate" text="Save" icon="download"></sp-button>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-form>
        </div>
    </div>
</template>

<script>
import DriverForm from './components/DriverForm'
import toast from '../../plugins/izitoast'
import DriversApi from '@/api/DriversApi'
import SpButton from '@/components/forms/Button'
import VehicleAutocomplete from '@/views/Vehicles/components/VehicleAutocomplete'

const driversApi = new DriversApi()

export default {
    name: 'DriverEdit',
    created () {
        this.id = this.$route.params.id
        this.getDriver()
    },
    components: {
        VehicleAutocomplete,
        SpButton,
        DriverForm
    },
    data () {
        return {
            id: null,
            valid: false,
            form: {
                name: '',
                firstName: '',
                lastName: '',
                phoneNumber: '',
                organization: null,
                fleet: null,
                user: null,
                vehicle: null
            },
            formVehicle: {
                vehicle: null
            }
        }
    },
    mounted () {
    },
    methods: {
        async editDriver (form) {
            const {
                name,
                firstName,
                lastName,
                phoneNumber,
                organization,
                fleet,
                user
            } = form

            const response = await driversApi.editDriver({
                id: this.id,
                name,
                firstName,
                lastName,
                phoneNumber,
                organizationId: organization ? organization.id : null,
                fleetId: fleet ? fleet.id : null,
                userId: user ? user.id : null
            })

            if (!response.isSuccess) {
                return
            }

            toast.success('Driver successfully updated.')
        },
        async getDriver () {
            const response = await driversApi.getDriver(this.id)

            this.form.name = response.payload.name
            this.form.firstName = response.payload.firstName
            this.form.lastName = response.payload.lastName
            this.form.phoneNumber = response.payload.phoneNumber
            this.form.organization = response.payload.organization
            this.form.fleet = response.payload.fleet
            this.form.user = response.payload.user
            this.formVehicle.vehicle = response.payload.vehicle ? {
                id: response.payload.vehicle.id,
                registrationNumber: response.payload.vehicle.name
            } : null
            this.form.vehicle = this.formVehicle.vehicle
        },
        async validate () {
            this.valid = this.$refs.form.validate()
            if (!this.valid) {
                return false
            }

            if (this.formVehicle.vehicle || null) {
                const response = await driversApi.assignDriverToVehicle(this.id, this.formVehicle.vehicle.id)

                if (!response.isSuccess) {
                    return
                }
                this.form.vehicle = this.formVehicle.vehicle
                toast.success('The device has been assigned to vehicle.')
            } else {
                const response = await driversApi.unassignDriverFromVehicle(this.id)
                if (!response.isSuccess) {
                    return
                }
                this.form.vehicle = this.formVehicle.vehicle
                toast.success('The device has been unassigned from vehicle.')
            }

            this.getDriver()
        }
    }
}
</script>

<style scoped>

</style>
